module.exports = __webpack_public_path__ + "img/ico_mapster.939dd07e.png";